import { Box, makeStyles } from "@material-ui/core";
import PercentageInput from "./PercentageInput";
import { BrandButton, SecondaryBrandButton } from "../CoreComponents/BrandButton";
import { useState, useEffect } from "react";
import { BrandAutocomplete } from "../CoreComponents/BrandAutoComplete";
import useAbortableFetch from "../../hooks/useAbortableFetch";
import { ButtonSize } from "../../constants/buttonConstants";

const useStyles = makeStyles((theme) => ({
    customInputDataWrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    actionsWrapper: {
        display: 'flex',
        flexDirection: 'row',
        columnGap: theme.spacing(2),
        alignItems: 'center'
    },
    addNewWrapper: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: theme.spacing(2),
        alignItems: 'flex-start',
        margin: `${theme.spacing(2)}px 0px`,
        width: '100%'
    },
    selectAccountHolderWrapper: {
        flex: 1
    },
    percentageInputWrapper: {
        flex: 1
    },
    autocompleteContainer: {
        width: '75%'
    }
}));

const AddRevenueSplitForm = ({
    selectedAccountHolder,
    setSelectedAccountHolder,
    inputPercentageData,
    setInputPercentageData,
    onSubmit,
    onCancel,
    mainAccountHolderId,
    disabledSubmitButton
}) => {
    const styles = useStyles();
    const abortableFetch = useAbortableFetch();

    const [percentageValidatorPassed, setPercentageValidatorPassed] = useState(false);
    const [accountHolderOptions, setAccountHolderOptions] = useState([]);

    useEffect(() => {
        fetchAccountHolders();
    }, []);

    const fetchAccountHolders = async () => {
        try {
            const accountHolders = await abortableFetch('GET', '/api/account-holder/my');
            if (accountHolders)
                setAccountHolderOptions(accountHolders.filter(ah => ah.id !== mainAccountHolderId));
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Box className={styles.addNewWrapper}>
            <Box className={styles.customInputDataWrapper}>
                <Box className={styles.selectAccountHolderWrapper}>
                    <Box className={styles.autocompleteContainer}>
                        <BrandAutocomplete
                            placeholder={'Select Account Holder'}
                            selectedAutoCompleteOption={selectedAccountHolder}
                            onSelectedAutoCompleteOption={setSelectedAccountHolder}
                            autoCompleteOptions={accountHolderOptions}
                        />
                    </Box>
                </Box>
                <Box className={styles.percentageInputWrapper}>
                    <PercentageInput
                        inputData={inputPercentageData}
                        setInputData={setInputPercentageData}
                        validatorPassed={[
                            percentageValidatorPassed, 
                            setPercentageValidatorPassed
                        ]}
                    />
                </Box>
            </Box>
            <Box className={styles.actionsWrapper}>
                <SecondaryBrandButton
                    onClick={onCancel}
                    size={ButtonSize.SMALL}
                >
                    Cancel
                </SecondaryBrandButton>
                <BrandButton 
                    onClick={onSubmit}
                    size={ButtonSize.SMALL}
                    disabled={disabledSubmitButton || !(selectedAccountHolder?.id && percentageValidatorPassed)}
                >
                    Save
                </BrandButton>
            </Box>
        </Box>
    )
}

export default AddRevenueSplitForm;